import axios from 'axios'
import Vue from 'vue'
import AuthService from "@/service/AuthService";

export default class CoachingStaffService {
    authService = new AuthService();
    config = {
        headers: { Authorization: `Bearer ${this.authService.getUserBearerToken()}` }
    };
    getCoachingStaffProfile(coachingStaffId) {
        const data = {
            CoachingStaffId: coachingStaffId
        };
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/CoachingStaff/GetCoachingStaffInfo', data, this.config);
    }
    saveCoachingStaffProfile(coachingStaff) {
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/CoachingStaff/SaveCoachingStaffInfo', coachingStaff, this.config);
    }
    addOrUpdatePlayer(coachingStaffId, player) {
        const data = {
            CoachingStaffId: coachingStaffId,
            Player: player
        };
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/CoachingStaff/AddOrUpdateCoachingStaffPlayer', data, this.config);
    }
    getPlayerList(coachingStaffId) {
        const data = {
            CoachingStaffId: coachingStaffId,
        };
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/CoachingStaff/GetCoachingStaffPlayerList', data, this.config);
    }
    deletePlayer(playerId) {
        const data = {
            CoachingStaffPlayerId: playerId
        };
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/CoachingStaff/DeletePlayer', data, this.config);
    }
    getCoachingStaffsList() {
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/CoachingStaff/GetCoachingStaffs', null, this.config);
    }
    deleteCoachingStaff(coachingStaffId) {
        const data = {
            CoachingStaffId: coachingStaffId,
        };
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/CoachingStaff/DeleteCoachingStaff', data, this.config);
    }
    updateCoachingStaffContacts(coachingStaffId, email, phone) {
        const data = {
            CoachingStaffId: coachingStaffId,
            Email: email,
            Phone: phone
        }
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/CoachingStaff/UpdateCoachingStaffContacts', data, this.config);
    }
}